import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Divider from "../Divider/Divider.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './FinanceProgram.css';import '../Grid/Grid.css';/* empty css                */
import Typography from "../Typography/Typography.js";
/* empty css                    */
const FinanceProgramTable = ({ items, className }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-finance-program-table", className), children: items.map(({ id, icon, label, value, logo, handleDetail }) => /* @__PURE__ */ jsxs(Row, { className: classnames("perxis-auto-finance-program-table__item-container"), children: [
    /* @__PURE__ */ jsx(Col, { span: 24, className: classnames("perxis-auto-finance-program-table__item"), children: /* @__PURE__ */ jsxs(Row, { wrap: false, gutter: [8, 0], justify: "space-between", align: "middle", children: [
      /* @__PURE__ */ jsx(Col, { flex: "auto", className: classnames("perxis-auto-finance-program-table__item-label-container"), children: /* @__PURE__ */ jsx(
        Typography.Text,
        {
          level: "small",
          color: "dark",
          className: classnames("perxis-auto-finance-program-table__item-label"),
          children: label
        }
      ) }),
      /* @__PURE__ */ jsxs(
        Col,
        {
          flex: "none",
          className: classnames("perxis-auto-finance-program-table__item-value-container"),
          onClick: handleDetail,
          children: [
            logo ? /* @__PURE__ */ jsx("img", { src: logo, alt: "Bank", className: classnames("perxis-auto-finance-program-table__item-image") }) : /* @__PURE__ */ jsx(
              Typography.Text,
              {
                level: "small",
                color: "darkest",
                className: classnames("perxis-auto-finance-program-table__item-value"),
                children: value
              }
            ),
            icon && /* @__PURE__ */ jsx(
              Typography.Text,
              {
                level: "small",
                color: "dark",
                className: classnames("perxis-auto-finance-program-table__item-icon"),
                children: icon
              }
            )
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Divider, {}) })
  ] }, id)) });
};
export {
  FinanceProgramTable as default
};
//# sourceMappingURL=FinanceProgramTable.js.map
